import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { TasksDrawer } from '../TasksDrawer/TasksDrawer';
import { useTasksDrawer } from '../tasksDrawerStore';
export const TasksDrawerRoot = ()=>{
    const { setTasksDrawerAvailable } = useTasksDrawer();
    useLayoutEffect(()=>{
        setTasksDrawerAvailable(true);
        return ()=>setTasksDrawerAvailable(false);
    }, [
        setTasksDrawerAvailable
    ]);
    return /*#__PURE__*/ _jsx(TasksDrawer, {});
};
